<template>
  <ElCheckbox :value="value" @input="handleInput" />
</template>

<script>
export default {
  name: 'LbTableCheckBox',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    handleInput(newVal) {
      if (newVal) this.$emit('check');
      else this.$emit('unCheck');
    },
  },
};
</script>
